import React, {useLayoutEffect, useRef, useState} from 'react';
import VideoModal from "./videoModal";
import {motion, useIsPresent, useScroll, useTransform} from "framer-motion";
import {Parallax} from "react-scroll-parallax";

function Banner(props:any) {
    const isPresent = useIsPresent();
    const videoRef = useRef<HTMLVideoElement>(null);
    const [playVideo, setPlayVideo] = useState(false)

    const onClick = () => setPlayVideo(true)


    useLayoutEffect(() => {
        if (videoRef.current) videoRef.current.play()
    }, [playVideo])

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const targetRef = useRef<HTMLDivElement | null>(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
        offset: ["end end", "end start"],
    });
    const spring = {
        type: "spring",
        stiffness: 700,
        damping: 300
    };
    const y = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);

    return (
        <div>

            <div className={`container mx-auto`}>
                <VideoModal
                    isOpen={isModalOpen}
                    videoUrl="https://res.cloudinary.com/mydeets/video/upload/v1693786558/home_page_image_path/aqi8a4wquqkwboqjlrdi.mp4"
                    onClose={closeModal}
                />
            </div>
            <motion.section style={{  }} ref={targetRef} className="overflow-hidden relative flex items-center justify-center h-screen-75">
                <div className="relative h-full w-full z-30 p-5 text-white main-gradient bg-opacity-50">
                    <div className={`flex flex-col-reverse md:flex h-full md:justify-between items-end`}>
                        <Parallax speed={8}>
                            <motion.div
                                animate={{y:0}}
                                initial={{y:"100%"}}
                                transition={{delay:.8,duration: .8, spring}}
                                className={`text-5xl lg:text-7xl xl:text-8xl tracking-normal  lg:w-6/12 pb-32 cormorant-font`}>Bringing Luxury<span className={`main-text-color`}> Design Promises</span> to life.

                            </motion.div>
                        </Parallax>

                        <motion.div
                            animate={{y:0}}
                            initial={{y:"100%"}}
                            transition={{delay:1,duration: .8, spring}}
                            className={``}>
                            <div className={`flex justify-center items-center md:pb-20 w-20  md:w-64 md:h-64 relative`}>
                                <div className={`absolute w-24 lg:w-64`}>
                                    <img src="/img/home/Group.png" alt="" className={`md:w-40  rotating-element`}/>
                                </div>
                                <div className={`absolute lg:w-20 w-10`}>
                                    <button onClick={openModal}>
                                        <img src="/img/home/play.png" alt="" className={`md:w-20 lg:-ml-7 `}/>
                                    </button>
                                </div>
                            </div>
                        </motion.div>

                    </div>

                </div>
                <motion.div style={{ y }} className={`absolute w-auto min-w-full md:min-w-50 md:right-0 min-h-full max-w-none`}>

                    <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        className={` w-auto min-w-full md:min-w-50 md:right-0 min-h-full max-w-none`}
                        onLoadedMetadata={(e) => (e.target as HTMLVideoElement).play()}
                        ref={videoRef}
                        onClick={onClick}
                    >
                        <source src={`https://res.cloudinary.com/mydeets/video/upload/v1693786558/home_page_image_path/aqi8a4wquqkwboqjlrdi.mp4`} type="video/mp4" />
                        {/*<source src={`https://res.cloudinary.com/mydeets/${mainVideo}`} type="video/mp4" />*/}
                    </video>
                </motion.div>
            </motion.section>

        </div>
    );
}

export default Banner;